import { render, staticRenderFns } from "./DepartureTabsGuides.vue?vue&type=template&id=37214ec4&"
import script from "./DepartureTabsGuides.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsGuides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports